export interface IAddressSuggestion {
  id: string;
  label: string;
  isContainer: boolean;
  containerSize: number;
}

export const emptyAddressSuggestion: IAddressSuggestion = {
  id: "",
  label: "",
  isContainer: false,
  /* API returns 0 or 1 for single addresses */
  containerSize: 0
};
